// src/components/Dashboard/PieChartSummary.jsx
import React, { PureComponent } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { withTranslation } from "react-i18next";

const COLORS = ["#22C55E", "#EF4444", "#F8CB00"];

class PieChartSummary extends PureComponent {
  render() {
    const { statistics, t } = this.props;

    // Build chart data from statistics including count, percentage and translated names
    const data = statistics
      ? [
          {
            key: "confirmed",
            name: t("pieChart.confirmed"),
            value: statistics.confirmed?.count,
            percentage: statistics.confirmed?.percentage,
          },
          {
            key: "declined",
            name: t("pieChart.declined"),
            value: statistics.declined?.count,
            percentage: statistics.declined?.percentage,
          },
          {
            key: "pending",
            name: t("pieChart.pending"),
            value: statistics.pending?.count,
            percentage: statistics.pending?.percentage,
          },
        ]
      : [];

    const totalBookings = statistics
      ? statistics.totalBookings ||
        data.reduce((sum, entry) => sum + (entry.value || 0), 0)
      : 0;

    return (
      <div
        style={{ width: "100%", height: "100%" }}
        className="pie-chart-container"
      >
        {/* Pie Chart */}
        <ResponsiveContainer width="100%" height="80%">
          <PieChart>
            {data.length > 0 && (
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            )}
            {/* Center "Total Orders" text */}
            <text
              x="50%"
              y="45%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "15px", fill: "#6B7280" }}
            >
              {t("pieChart.totalOrders")}
            </text>
            {/* Center total bookings number */}
            <text
              x="50%"
              y="58%"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "24px", fontWeight: "bold", fill: "#111827" }}
            >
              {totalBookings}
            </text>
          </PieChart>
        </ResponsiveContainer>

        {/* Statistics Cards */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            flexWrap: "wrap",
          }}
          className="statistics-cards"
        >
          {data.map((entry, index) => (
            <div
              key={`stat-card-${index}`}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: "0px 20px",
              }}
              className="statistics-card"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                  gap: "5px",
                }}
              >
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: COLORS[index % COLORS.length],
                    marginRight: "6px",
                  }}
                ></div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "rgb(15, 23, 42)",
                  }}
                >
                  {entry.name}
                </div>
              </div>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "rgb(17, 24, 39)",
                  marginBottom: "8px",
                  marginTop: "8px",
                }}
              >
                {entry.value || 0}
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "rgb(156, 163, 175)",
                }}
              >
                {entry.percentage || 0}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

// <— Here we specify the “dashboard” namespace so your pieChart.* keys are picked up:
export default withTranslation("dashboard")(PieChartSummary);
